<script setup>
    import { ref } from 'vue';
    import axios from 'axios';
    import * as bootstrap from 'bootstrap';

    const props = defineProps(['url']);

    const newEntry = ref({
        Rechnungsempfaenger: '',
        Antrag: '',
        Tarifnummer: '',
    });
    const submitResult = ref(null);
    const submitError = ref(null);
    const emptyFields = ref(false); // because no check in the backend

    // adds entry to waiting list. If successful, shows in modal, which disappears after 5s. The page reloads 0.5s later.
    async function addToWaitingList() {
        submitResult.value = null;
        submitError.value = null;
        // if these three mandatory fields remain empty, cancel and show an error message. Done because backend performs no check.
        if ((newEntry.value.Rechnungsempfaenger === '' && newEntry.value.Antrag === '') || newEntry.value.Tarifnummer == '') {
            emptyFields.value = true;
            return;
        } else {
            emptyFields.value = false;
        }
        await axios.put(props.url, newEntry.value)
        .then(function (response) {
            submitResult.value = response;
            setTimeout(function() {
                const currentModal = document.querySelector('#createEntry');
                const modal = bootstrap.Modal.getInstance(currentModal);
                modal.hide();
            }, 5000);
            setTimeout(function() {
                window.location.reload();
            }, 5500);
        }).catch(function (error) {
            submitError.value = error;
        })
    }

</script>

<template>
    <form @submit.prevent="addToWaitingList()">
        <div class="form-group">
            <label for="Rechnungsempfaenger">Rechnungsempfängernummer</label>
            <input id="Rechnungsempfaenger"
                type="text"
                v-model="newEntry.Rechnungsempfaenger"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.Rechnungsempfaengernummer !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Rechnungsempfaenger !== 'undefined')">
                {{ submitError.response.data.Rechnungsempfaenger[0] }}
            </div>
        </div>
        <div class="form-group">
            <label for="Antrag">Antragsnummer</label>
            <input id="Antrag"
                type="text"
                v-model="newEntry.Antrag"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.Antrag !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Antrag !== 'undefined')">
                {{ submitError.response.data.Antrag[0] }}
            </div>
        </div>
        <div class="form-group">
            <label for="Tarifnummer">Tarifnummer</label>
            <input id="Tarifnummer"
                type="text"
                v-model="newEntry.Tarifnummer"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.Tarifnummer !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Tarifnummer !== 'undefined')">
                {{ submitError.response.data.Tarifnummer[0] }}
            </div>
        </div>

        <button type="submit" class="btn btn-primary">
            Wartelisteneintrag speichern
        </button>
    </form>

    <div class="alert alert-success" role="alert" v-if="submitResult !== null && (submitResult.status === 201 || submitResult.status === 200)">
        <span>Nutzer erfolgreich gesperrt.</span>
    </div>
    <div class="alert alert-danger" role="alert" v-if="emptyFields === true">
        Bitte füllen Sie alle Felder aus.
    </div>

</template>
